import React, { useEffect } from 'react';
import './AboutPopup.css';

function AboutPopup({ onClose }) {
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Close on Outside Click
  const handleOverlayClick = (e) => {
    if (e.target.className === 'about-popup-overlay') {
      onClose();
    }
  };

  return (
    <div className="about-popup-overlay" onClick={handleOverlayClick}>
      <div className="about-popup-content">
        
        <div className="about-sidebar">
          <div className="sidebar-logo">
            <img 
              src={`${process.env.PUBLIC_URL}/Image/Logo.png`} 
              alt="Logo" 
              style={{ width: '100%', maxWidth: '150px', height: 'auto', objectFit: 'contain' }}
            />
          </div>
          <h2 className="sidebar-title">អំពីយើង</h2>
          <p className="sidebar-tagline">About</p>
          <div className="sidebar-divider"></div>
          <p className="sidebar-contact-info">
            ទំនាក់ទំនងយើងខ្ញុំ<br/>
            សម្រាប់ព័ត៌មានបន្ថែម
          </p>
        </div>

        <div className="about-main">
          <button className="about-popup-close" onClick={onClose} aria-label="Close">
            &times;
          </button>
          
          <div className="about-scroll-container">
            <section className="about-intro-block">
              <h3>គោលបំណង</h3>
              <p>
                គេហទំព័រនេះ ត្រូវបានបង្កើតឡើង ក្នុងគោលបំណងជួយសម្រួលក្នុងការស្វែងរកមាត្រាច្បាប់សំខាន់ៗ ឬ សេចក្ដីពន្យល់នៃមាត្រា ដែលពាក់ព័ន្ធនឹងពាក្យគន្លឹះ ដើម្បីបង្កើនប្រសិទ្ធភាព ភាពឆាប់រហ័ស និង ភាពងាយស្រួល ក្នុងការវិភាគ និង ដោះស្រាយសំណុំរឿង របស់និស្សិតច្បាប់ អ្នកស្រាវជ្រាវ មេធាវី និង អ្នកប្រកបវិជ្ជាជីវៈផ្នែកច្បាប់។
              </p>
            </section>

            <section className="about-disclaimer" style={{ 
              backgroundColor: '#fffdf0', 
              border: '1px solid #ffeeba', 
              padding: '20px', 
              borderRadius: '8px',
              marginTop: '30px',
              marginBottom: '30px'
            }}>
              <h3 style={{ 
                color: '#856404', 
                fontFamily: 'Moul, cursive', 
                fontSize: '1em', 
                marginBottom: '10px',
                display: 'flex', 
                alignItems: 'center',
                gap: '10px'
              }}>
                ⚠️ ខ បដិសេធទទួលខុសត្រូវ (Disclaimer)
              </h3>
              <p style={{ color: '#856404', fontSize: '0.95em', margin: 0 }}>
                អត្ថបទច្បាប់ដែលបានបង្ហាញនៅលើគេហទំព័រនេះ អាចនឹងមានកំហុសអក្ខរាវិរុទ្ធដោយអចេតនា។ 
                ដូចនេះ សូមលោកអ្នកផ្ទៀងផ្ទាត់ជាមួយច្បាប់ដើមនៃច្បាប់នោះ មុននឹងយកទៅប្រើប្រាស់ជាផ្លូវការ។
              </p>
            </section>

            <div className="contact-strip">
              <div className="c-item">Email: info@chbabfinder.com</div>
              <div className="c-item">Tel: (+855) 12 799 633</div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default AboutPopup;
